.overlay-step-bar__container {
  align-items: center;
  background-color: var(--color-grey-200);
  display: flex;
  height: 2.5rem;
  justify-content: center;
  overflow-y: hidden;
}

.overlay-step-bar__step-wrapper {
  background-color: var(--color-grey-200);
  height: 100%;
  position: relative;
}

.overlay-step-bar__step-wrapper:not(:last-child)::after {
  border-bottom: 1.5rem solid transparent;
  border-left: 1rem solid var(--color-grey-200);
  border-top: 1.5rem solid transparent;
  content: "";
  position: absolute;
  right: -0.25rem;
  top: -0.25rem;
  z-index: 10;
}

.overlay-step-bar__step-wrapper:not(:last-child)::before {
  border-bottom: 1.5rem solid transparent;
  border-left: 1rem solid var(--color-uva-white);
  border-top: 1.5rem solid transparent;
  content: "";
  position: absolute;
  right: calc(-0.25rem - 0.25rem);
  top: -0.25rem;
  z-index: 5;
}

.overlay-step-bar__step {
  align-items: center;
  appearance: none;
  background-color: transparent;
  border: none;
  color: var(--color-grey-700);
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: var(--font-size-default);
  height: 100%;
  margin-left: 0.5rem;
  padding: 0 2rem 0 1.5rem;
  position: relative;
  width: calc(100% - 0.75rem);
}

.overlay-step-bar__step--label {
  display: none;
  text-decoration: none;
  white-space: nowrap;
}

.overlay-step-bar__step--label-show {
  display: block;
}

.overlay-step-bar__step--index {
  margin-right: 0.5rem;
}

.overlay-step-bar__step--label:hover {
  text-decoration: underline;
}

.overlay-step-bar__step--active .overlay-step-bar__step--label {
  display: block;
}

.overlay-step-bar__step:hover .overlay-step-bar__step--index,
.overlay-step-bar__step:hover .overlay-step-bar__step--label {
  text-decoration: underline;
}

@media (min-width: 70rem) {
  .overlay-step-bar__step--label {
    display: block;
  }

  .overlay-step-bar__step:hover .overlay-step-bar__step--index {
    text-decoration: none;
  }
}

.overlay-step-bar__step:focus-visible {
  outline: 0.125rem dotted var(--color-navy-600);
  outline-offset: -0.25rem;
  z-index: 15;
}

.overlay-step-bar__step--active {
  color: var(--color-uva-black);
  font-weight: var(--semibold);
}

.overlay-step-bar__step--active:hover .overlay-step-bar__step--index,
.overlay-step-bar__step--active:hover .overlay-step-bar__step--label {
  cursor: default;
  text-decoration: none;
}
